<ng-container>
    <div class="print-loading-indicator__container">
        <ms-loading-indicator></ms-loading-indicator>
    </div>
    <div class="print-loading-indicator__text">{{ sitecore.myBets_Print.LoadingIndicatorText }}</div>
</ng-container>
